module.exports = __webpack_public_path__ + "img/solution_round_one.566c5a3d.png";